// src/components/FindId.tsx

import React, { useState } from 'react';
import { FaStarOfLife } from 'react-icons/fa6';
import { instance } from '../api/axiosInstance'; // Adjust the path as needed

const FindId: React.FC = () => {
  const [email, setEmail] = useState('');
  const [userId, setUserId] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Handler to find ID by email
  const handleFindId = async () => {
    // Reset previous states
    setUserId(null);
    setError(null);

    // Basic Email Validation
    if (!email) {
      setError('이메일을 입력해주세요.');
      return;
    }

    // Optionally, add more robust email validation here

    setLoading(true);
    try {
      const response = await instance.get('/api/users/username', {
        params: { email },
      });
      setUserId(response.data.username);
    } catch (err: any) {
      if (err.response) {
        // Server responded with a status other than 2xx
        setError(err.response.data.message || '문제가 발생했습니다.');
      } else if (err.request) {
        // Request was made but no response received
        setError('서버로부터 응답을 받지 못했습니다.');
      } else {
        // Something else happened
        setError('오류가 발생했습니다.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='mobile:px-4'>
      <div className="my-10">
        <h2 className="font-semibold text-xl mb-3 text-center">
          등록된 이메일 주소로 아이디 찾기
        </h2>
        <p className="font-medium text-[#747474] text-sm text-center mb-10">
          가입 당시 입력한 이메일 주소를 입력해주세요.
        </p>
      </div>
      <label
        htmlFor="email"
        className="text-[#111] font-medium mb-2 text-base flex gap-1"
      >
        이메일
        <span>
          <FaStarOfLife className="text-[#ef4444] text-[8px]" />
        </span>
      </label>
      <input
        type="email"
        id="email"
        placeholder="이메일 입력"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="w-full px-4 py-4 border-b placeholder:text-[#c8c8c8c8] text-MainTextColor focus:outline-none"
      />
      {loading && (
        <div className="mt-4 text-center text-gray-500">검색 중...</div>
      )}
      {error && (
        <div className="p-4 bg-red-100 text-red-700 mt-4 rounded">
          {error}
        </div>
      )}
      {userId && (
        <div className="p-6 bg-white shadow-sm rounded-lg mt-8">
          <h1 className="font-semibold text-xl text-center">{userId}</h1>
        </div>
      )}
      <button
        onClick={handleFindId}
        className="bg-[#04c2c5] text-white w-full mt-10 tracking-wide shadow-sm font-bold text-base py-4 rounded-full hover:bg-opacity-70 transition duration-300"
        disabled={loading}
      >
        {loading ? '검색 중...' : '아이디 찾기'}
      </button>
    </div>
  );
};

export default FindId;
